import React, { useState,useEffect } from "react";
import { getImage } from 'gatsby-plugin-image';
import * as styles from './review.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle as faCH } from '@fortawesome/free-regular-svg-icons'
import { faCircle } from '@fortawesome/free-solid-svg-icons'

const Review = ({ revTitle, revAuthor, children, revImage, reviews = [] }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [displayReviews, setDisplayReviews] = useState([]);

  const handleSlideChange = (index) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
      //add slideshow reviews
      let tmpDisplayReviews = [];
      if(reviews && reviews.length > 0){
          let r,tmpimage,tmpbgimg;
          for (r of reviews){
              tmpimage = r.image ? getImage(r.image) : false;
              tmpbgimg = tmpimage ? tmpimage.images.sources[0].srcSet.split(" ")[0] : '';
              tmpDisplayReviews.push({displayTitle:r.title, displayAuthor:r.author,displayText:r.review.review, displayImage:tmpbgimg});
          }
      }
      //add in the original review
      const image = revImage ? getImage(revImage) : false;
      const bgimg = image ? image.images.fallback.src : '';
      if(image){
        tmpDisplayReviews.push({displayTitle:revTitle, displayAuthor:revAuthor, displayText:children, displayImage:bgimg});
      }
      setDisplayReviews(tmpDisplayReviews);
    }, []);


  return (
    <section className={styles.bgStyle}>
      {displayReviews.length > 0 && (
      <div className="container" style={{ 
          backgroundImage: 'url(' + displayReviews[currentSlide].displayImage + ')', 
          backgroundSize: 'cover', 
          backgroundRepeat: 'no-repeat', 
          backgroundPosition: 'center',transition: 'background-image 1s ease-in-out' }}>
          <div className={styles.transbkgrnd} >
          <div className="columns">
              <div className="column" >
                  <img src="/imgs/lquote.png" alt="left quote" style={{maxWidth:'100px'}}/>
              <h1 className={`${styles.fontFaceMoontime} ${styles.headStyle} ${styles.lh}`}>{displayReviews[currentSlide].displayTitle}</h1>
              <p className={`${styles.center} ${styles.responsivePadding}`}>{displayReviews[currentSlide].displayText}</p>
              <br />
              <p className={styles.center}>- <em>{displayReviews[currentSlide].displayAuthor}</em></p>
              <img src="/imgs/rquote.png" alt="right quote" style={{ float: 'right',maxWidth:'100px' }} />
                  <br />
            </div>
          </div>
              <div style={{textAlign:'center',clear:'both'}}>
            {displayReviews.length > 1 && displayReviews.map((review, index) => (
                <FontAwesomeIcon icon={ index === currentSlide ? faCircle : faCH } 
                onClick={() => handleSlideChange(index)}
                size="lg" 
                key={index}
                className={styles.fontColorWhite}
                style={{paddingRight:'5px',cursor:'pointer'}} />
            ))}
            </div>
        </div>
      </div>
      )}
    </section>
  );
};

export default Review;

